import React, { useEffect, useRef, useState } from "react";
import useInterval from "hooks/useInterval";
import s from "./GameUI.module.scss";
import { useSelector } from "react-redux";
import cx from "classnames";
import AudioManager from "scripts/util/AudioManager";
import store from "store";
import { setState } from "store/game";
// import { setState as setUiState } from 'store/ui'

import GameOver from "components/GameOver";
import PauseButton from "components/PauseButton";
import PauseMenu from "components/PauseMenu";
import ProgressBar from "components/ProgressBar";
import Splat from "components/UiEffects/Splat";

import Timer from "assets/images/new-ui/timer-frame.png";
import ScoreFrame from "assets/images/new-ui/score-frame.png";

import EventPubSub from "scripts/util/EventPubSub";
import GiftIdea from "components/GiftIdea";

GameUI.defaultProps = {};

export default function GameUI(props) {
  const { paused, points, progress, time } = useSelector((state) => state.game);
  const { isLandscape } = useSelector((state) => state.ui);
  const [startCount, setStartCount] = useState(3);
  const [gameDebug, setGameDebug] = useState(false);
  const [press, setPress] = useState(false);
  const [pressUp, setPressUp] = useState(true);
  const [pressTime, setPressTime] = useState(null);
  const [gameStarted, _setGameStarted] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [playSplatEffect, setPlaySplatEffect] = useState(0);
  const gameStartedRef = useRef(false);
  const giftsCollected = useRef([]);

  const setGameStarted = (val) => {
    _setGameStarted(val);
    gameStartedRef.current = val;
  };

  useInterval(countDown, 1000, gameStarted);


  useEffect(() => {
    if (window.location.search.includes("debug")) {
      setGameDebug(true);
    }
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        pause();
      }
    });
    EventPubSub.subscribe("resume", resume);
    EventPubSub.subscribe("remote", remoteHandler);
    EventPubSub.subscribe("game", showGameOver);
    EventPubSub.subscribe("collectGift", handleCollectGift);
    EventPubSub.subscribe("snowSplat", handleSnowSplat);

    return () => {
      EventPubSub.unsubscribe("resume", resume);
      EventPubSub.unsubscribe("remote", remoteHandler);
      EventPubSub.subscribe("game", showGameOver);
    };
  }, []);

  useEffect(() => {
    if (paused === true) {
      AudioManager.stopTracks();
      // AudioManager.pauseTracks()
    } else if (gameStarted) {
      AudioManager.playTrack("gameMusic");
      // AudioManager.resumeTracks()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paused]);

  useEffect(() => {
    if (isLandscape) {
      pause();
    }
  }, [isLandscape]);

  const remoteHandler = (payload) => {
    if (payload === "press") {
      setPress(true);
      setPressUp(false);
      setPressTime(0);
      console.log("Pressed");
    }
    if (payload === "pressUp") {
      setPressUp(true);
      setPress(false);
      setPressTime(null);
      console.log("PressUp");
    }
  };

  const resume = () => {
    // AudioManager.playSound('uiTransition')
  };

  const pause = () => {
    EventPubSub.emit("pause");
    store.dispatch(setState({ paused: true }));
    setPressUp(true);
    setPress(false);
    setPressTime(0);
  };

  function countDown() {
    if (startCount <= 1) {
      setGameStarted(true);
      return;
    }
    setStartCount(startCount - 1);
  }

  function showGameOver(msg) {
    if (msg === "gameover") {
      setGameOver(true);
    }
  }

  const handleCollectGift = () => {
    giftsCollected.current.push("");
  };

  const handleSnowSplat = () => {
    setPlaySplatEffect((playSplatEffect) => playSplatEffect + 1);
    AudioManager.playSound('splat')
  };

  return (
    <div className={cx(s.GameUI, { [s.GameDebug]: gameDebug })}>
      <GameOver active={gameOver} />
      <img className={cx(s.border, s.left)} src={ScoreFrame} alt="" />
      <img className={cx(s.border, s.right)} src={Timer} alt="" />
      <div className={s.score}>
        <span className={s.number}>{pad(points, 4)}</span>
      </div>
      <div className={s.timeWrapper}>
        <span className={s.number}>{formatTime(time)}</span>
        {/* <PauseButton
          className={s.PauseButton}
          active={press && pressTime >= 0 && gameStarted && !paused}
        /> */}
      </div>
      {giftsCollected.current.map((t, index) => (
        <GiftIdea key={index} />
      ))}
      <ProgressBar className={s.ProgressBar} progress={progress} />
      {paused && <PauseMenu />}
      <div className={cx(s.countDown, { [s.active]: startCount > 1 })}>
        <h3>{startCount}</h3>
      </div>
      <Splat play={playSplatEffect} />
    </div>
  );
}

function pad(num, size) {
  if (num < 0) {
    return num;
  }
  let s = "000000000" + num;
  return s.substr(s.length - size);
}

function formatTime(seconds) {
  const min = "00" + Math.floor(seconds / 60);
  const sec = "00" + (seconds % 60);
  const formattedMin = min.substr(min.length - 2);
  const formattedSec = sec.substr(sec.length - 2);
  return `${formattedMin}:${formattedSec}`;
}
